
export class ELearningDashboardClass {
    constructor() {
        this.Students = [];
    }

    Name: string;
    ID: number; //hbclassid
    CurriculumID: number;
    CurriculumUrl: string;
    ClassHomePageUrl: string;
    Students: ELearningDashboardStudent[];
    Hidden: boolean;
    SchoolID?: number;

    NoLessonsYet: boolean;
}

export class ELearningDashboardStudent {
    Name: string;
    ID: number;
    NeedsAssignment: boolean;
    ActiveLessons: number;
    LastAssignmentSubmitDate: string;
    NeedsGradingCount: number;
    NeedsGradeReleasedCount: number;
}

export class User {
    UserID: number;
}

export class Teacher{
    UserID: number;
    CustID: number;
    UserName: string;
    FirstName: string;
    LastName: string;
    Active: boolean;
    UserTypeId: number;
    }

export class Teachers {
    IsAdmin: boolean;
    Teachers: Teacher[];
}

export class ELearningDashboardState {

    Collapsed: number[] = [];
    StudentFilter?: number;
    Anchor?: number;
    TeacherID?: number;

    copyFromModel(state: ELearningDashboardState){
        this.StudentFilter = state.StudentFilter;
        this.Anchor = state.Anchor;
        if(!state.Collapsed){
            this.Collapsed = [];
        }
        else{
            state.Collapsed.forEach(item => {
                this.Collapsed.push(item);
            });
        }
        this.TeacherID = state.TeacherID;
    }
}

export class StudentLesson{
    AssignmentName: string;
    StartDate: string;
    DueDate: string;
    ClassName: string;
    ClassDesc: string;
    TeacherFullName: string;
    AssignmentID: number;
}

export class Lesson{
    LessonVersionID: number;
    Name: string;
    LessonID: number;
}

export enum StudentFilterValues{
    All = 1,
    NeedsAttention = 2
}

////////// Gradebook, Assignment, and Student Pages

export class GradebookVM{
    ClassDetails: ClassDetails;
    Assignments: Assignment[];
}

export class StudentVM{
    StudentID: number;
    StudentName:string;
    ClassDetails: ClassDetails;
    Assignments: AssignmentStudentAttempt[];
}

export class AssignmentVM{
    ClassDetails: ClassDetails;
    CurriculumItemID: number;
    Sequence: number;
    LessonID: number;
    LessonName: string;
    AssignedStudentAttempts: AssignedStudentAttempt[];
}
export class AssignedStudentAttempt{
    StudentID: number;
    StudentName: string;
    AttemptCount: number;
    SubmittedAsComplete: boolean;
    GradeReleased: boolean;
    AnswerKeyReleased: boolean;
    SentBack: boolean;
    Graded: boolean;
    Grade: string;
    NeedsAttention: boolean;
    AttemptID: number;
    Status: string;
    CompleteDate: string;
    CurriculumItemID?: number;
    Sequence?: number;
    AssignmentID: number;
    LessonName: string;
    StartDate: string;
    DueDate: string;
    AssignmentGroupID?: number;
    HasMultiClassAssignmentGroup: boolean;
    LessonID?: number;
}

export class Assignment{
    CurriculumItemID: number;
    Sequence: number;
    AssignmentID: number;
    LessonName: string;
    StartDate: string;
    DueDate: string;
    ClassDetails: ClassDetails;
    AssignedStudentAttempts: AssignedStudentAttempt[];
    UnitID?: number;
    UnitName?: string;
}

export class AssignmentStudentAttempt{
    CurriculumItemID: number;
    Sequence: number;
    AssignmentID: number;
    LessonName: string;
    StartDate: string;
    DueDate: string;
    LessonID?: number;
    StudentID: number;
    StudentName: string;
    AttemptCount: number;
    SubmittedAsComplete: boolean;
    GradeReleased: boolean;
    AnswerKeyReleased: boolean;
    SentBack: boolean;
    Grade: string;
    Graded: boolean;
    NeedsAttention: boolean;
    AttemptID: number;
    Status: string;
    CompleteDate: string;
    HasMultiClassAssignmentGroup: boolean;
    AssignmentGroupID: number;
}

export class ClassDetails{
    ClassID: number;
    ClassName: string;
    ClassHomePageUrl: string;
}

export class ClassForListing{
    HBClassID: number;
    ClassName: string;
    ClassDesc: string;
    TeacherID: number;
    TeacherFullName: string;
}

export class ReassignStudentModel{
    StudentID: number;
    AssignmentID: number;
    ClassID: number;
    ReassignShowIcon: boolean;
    ReassignShowAnswer: boolean;
}

export class LessonProgressSaveModel{
    ClassID: number;
    AssignmentID: number;
    StudentID: number;
}

export class LessonProgressLockSaveModel extends LessonProgressSaveModel{
    Lock: boolean;
}

export class LessonProgressSaveGradeModel extends LessonProgressSaveModel{
    Grade: string;
    FeedbackText: string;
}

export class LessonProgressReleaseAllModel{
    Threshold: number;
    Reassign: boolean;
    ClassID: number;
    ReassignShowIcon: boolean;
    ReassignShowAnswer: boolean;
}

export class LessonProgressReleaseAllByStudent extends LessonProgressReleaseAllModel{
    StudentID: number;
    DiagnosticExamID: number;
}

export class LessonProgressReleaseAllByAssignment extends LessonProgressReleaseAllModel{
    AssignmentID: number;
}


export class LessonProgressReleaseAllResult {
    AttemptedRelease: number;
    AttemptedReassign: number;
    CompletedRelease: number;
    CompletedReassign: number;
    FailedReassignList: StudentLesson[];
    FailedReleaseList: StudentLesson[];
    AllReleaseSuccessful: boolean;
    AllReassignSuccessful: boolean;
}

export class UnAssignModel{
    ClassID: number;
    LessonVersionID: number;
    StudentID: number;
}
export class SimpleStudent{
  StudentID : number;
  StudentName : string;
}

export class StudentForListing extends SimpleStudent {}
export class ClassWithStudentsForListing extends ClassForListing {
  Students: StudentForListing[]
}

// Janak Shah changed name of class to StudentForDiagnosticSimpleStudent from StudentForDiagnostic due to name conflict
export class StudentForDiagnosticSimpleStudent extends SimpleStudent {}
export class CreateAssignmentOptions {
  RemoveExtendedResponse: boolean;
  AssignOnlyUnassignedStudents: boolean; // Change as needed to match other changes we discussed
  StartDate: Date;
  EndDate: Date;
}
// Janak Shah added classIDs parameter for sending classId for selected class
export class CreateAssignmentClass {
  classIDs: number;
  StudentIDs: number[];
}

export class CreateAssignmentsModel extends  CreateAssignmentOptions {
  AssignmentIDs: number[];
  Classes: CreateAssignmentClass[];
}
////////// Diagnostics and Detail Page

export class StudentForDiagnostic {
    StudentID : number;
    StudentName : string;
    Grade: string;
}

export class StudentForDiagnosticGradeList extends StudentForDiagnostic{
    AttemptID: number;
}

export class StudentForDiagnosticDetail {
  StudentID : number;
  StudentName : string;
  LessonsAssigned: number;
  LessonsCompleted: number;
  LastSubmittedDate: string;
  NeedsAttentionCount: number;
  Grade: string;
  AverageILPGrade: string;
  Assignments: AssignmentForStudentDiagnostic[]
}

export class AssignmentForStudentDiagnostic {
  LessonID: number;
  LessonName: string;
  AssignmentID: number;
  AttemptID: number;
  Grade: string;
  GradeReleased: boolean;
  SentBack: boolean;
  SubmittedAsComplete: boolean;
  SubmitDate: string;
}

export class DiagnosticVM {
  DimDistrictExamID: number;
  DiagnosticExamID : number;
  LessonID : number;
  LessonName : string;
  AssignmentID: number;
  DiagInProgress : number;
  LessonsComplete : number;
  LessonsTotal : number;
  StudentsNeedAttentionCount : number;
  StudentsUnassigned : StudentForDiagnostic[];
  StudentsNeedDiagGraded: StudentForDiagnosticGradeList[];
  StudentsawaitingILP: StudentForDiagnostic[];
  StudentsWithLessons: StudentForDiagnosticDetail[];
  StudentsLessonSkipList: StudentForDiagnostic[];
  StudentsYieldedNoILP: StudentForDiagnostic[];
  StudentsNotStartedExam: StudentForDiagnosticGradeList[];
  StudentsExamInProgress: StudentForDiagnosticGradeList[];
  IsELearning: boolean;
  DiagExamSkippedCount: number;
  DiagLessonsSkippedCount: number;
}

export class DiagnosticsVM{
    ClassID: number;
    ClassName: string;
    Diagnostics: DiagnosticVM[]
}

export class DiagnosticsList{
  DimDistrictExamID: number;
  ExamDesc: string;
}

export class DiagnosticSkipStudentModel {
  DiagnosticExamID: number;
  StudentID: number;
  Skip: boolean;
}

export class DiagnosticLessonsSkipStudentModel extends DiagnosticSkipStudentModel
{
    AAYieldNoILP: boolean;
}

export class DiagnosticRemoveFromSkipStudentModel {
  DiagnosticExamID: number;
  StudentID: number[];
}

export class AssignStudentDiagnosticModel {
  DiagnosticExamID: number;
  StudentID: number;
}

export class AssignAllDiagnosticModel {
  DiagnosticExamID: number;
}

export class AssignDiagnosticLessonsModel {
  DiagnosticExamID: number;
  StartDate: Date;
  EndDate: Date;
  AssignFromOption: number;
  RemoveExtendedResponseOption: boolean;
}

export class AssignStudentDiagnosticLessonsModel {
  DiagnosticExamID: number;
  StudentID: number;
  StartDate: Date;
  EndDate: Date;
  AssignFromOption: number;
  RemoveExtendedResponseOption: boolean;
}

export class UnassignDiagnosticLessonsVM{
    DiagnosticExamID: number;
    StudentID: number;
    AssignmentID: number;
}

export class CreateDiagnosticVM{
    constructor(dimDistrictExamID: number, hBClassID: number){
        this.DimDistrictExamID = dimDistrictExamID;
        this.HBClassID = hBClassID
    }

    DimDistrictExamID: number;
    HBClassID: number;
}


////////// View Work Page

export class ViewWorkDataQuestionResponse {
  IsCorrect: boolean;
  Response: string;
}

export enum ViewWorkRTIType{
    "",
    "Jump Start",
    "Visual Model",
    "Skill Builder",
    "Guided Practice",
    "Independent Practice",
    "Reflection"
}

export enum ViewWorkConsumerCurriculumRTIType{
  "",
  "Jump Start",
  "Visual Model",
  "Skill Builder",
  "Independent Practice",
}
export enum ViewWorkTemplateType{
    "",
    "Prior Knowledge",
    "Vocabulary",
    "Learning Component",
    "Guided Practice",
    "Independent Practice",
    "Extended Response",
    "Test Ready",
    "Lab",
    "Reflection"
}
export enum ViewWorkConsumerCurriculumTemplateType{
  "",
  "Vocabulary",
  "Learning Component",
  "Independent Practice",
  "Test Ready",
  "Lab",
}
export class ViewWorkDataQuestion {
  QuestionTitle: string;
  LessonItemID: number;
  RTIModuleType: number;
  TemplateComponentType: number;
  QuestionTypeEnumValue: number;
  PointsEarned: number;
  PointsAvailable: number;
  SequenceNumber: number;
  QuestionText: string;
  AvailableResponses: ViewWorkDataQuestionResponse[];
  StudentResponse: string[];
  AnswerList?: string[];
  StandardsCovered: string[];

  HideFromConsumerCurriculum: boolean;
}

export class ViewWorkDataVM {
  StudentID: number;
  AssignmentID: number;
  AttemptID: number;
  Grade: number;
  Questions:  ViewWorkDataQuestion[]
}

export class ViewWorkDataModel {
  AttemptID: number;
  AssignmentID: number;
}

export class SubmitQuestionModel{
  LessonItemID: number;
  PointsEarned: number;
}

export class SubmitViewWorkModel {
  StudentID: number;
  AttemptID: number;
  Questions: SubmitQuestionModel[]
}

export class SubmitViewWorkResponseModel {
  Graded: boolean;
  Success: boolean;
}

export enum QuestionTypeEnum{
    Fact = 1,
    TrueFalse = 2,
    MultipleChoice = 3,
    ShortAnswer = 4,
    Essay = 5,
    Discussion = 6,
    Upload = 7,
    ItemBank = 8,
    ItemLogic = 9
}

export enum QuestionTypeRedirectEnum{
    Discussion = 6,
    Upload = 7,
    ItemBank = 8,
    ItemLogic = 9
}

export class LoginAccountResult{
  isLoggedIn: boolean;
}

export class LoginAccountModel {
  Email: string;
  Password: string;
}

                  ////////////// Assignment Attempts View Work Dialog

export class ViewWorkDialogAssignmentAttempt{
  AttemptID: number;
  SubmitDate: string;
}

export class GetViewWorkDialogAssignmentAttempts{
  StudentID: number;
  AssignmentID: number;
}

// Create Account
export class CreateAccountModel {
  UserID?: number;
  FirstName?: string;
  LastName?: string;
  Email?: string;
  Password?: string;
  PasswordConfirm?: string;
  OldPassword?: string;
}
////
export class CurriculumDataModel {
  CurriculumID: number;
  CurriculumName: string;
  Price?: string;
  CurriculumDesc?: string;
  ImagePath: string;
}
export class CurriculumModel {
  Curriculums?: CurriculumDataModel[];
  ConsumerSubjectName: string;
}

export class SubjectModel {
  Subjects?: CurriculumModel[];
  ConsumerGradeName: string;
}

export class CurriculaVMModel {
  //UserCurriculumCredits: number;
  IsTeacher: boolean;
  Grades: SubjectModel[];
}

///

export class HasAlreadyPaidRedirectModel{
  HasAlreadyPaid: boolean;
  ClassID: number;
}
///
export class ExistingStudentCurriculumRegisterModel {
  CurriculumID: number;
  StudentID: number;
  CurriculumProductLevelID: number;
  Password: string;
}

export class ExistingStudentConsumerCurriculumRegisterModel{
  StudentConsumerCurriculumID: number;
  CurriculumProductLevelID: number;
  Password: string;
}
////
export class SelectedCurriculumModel { // same as CurriculumDataModel
  CurriculumID: number;
  CurriculumName: string;
  Price: string;
  CurriculumDesc: string;
  HasUnitTests: boolean;
  LessonCount: number;
  ImagePath: string;
}
////
export class RegisterNewStudent {
  StudentFirstName: string;
  StudentLastName: string;
  StudentEmail: string;
  Password?: string; // default if null
}
////
export class StudentModel {
  StudentID: number;
  StudentFirstName: string;
  StudentLastName: string;
  StudentEmail?: string;
}
////
export class StudentCourseModel { //StudentAssignmentListing in RP
  IsTeacher: boolean;
  StudentCurriculums: StudentClassMappingModel[]
}

export class StudentClassMappingModel {
  StudentFirstName: string;
		StudentLastName: string;
		StudentID: number;
		ClassID: number;
		ClassName: string;
    HasPaid: boolean;
    HasCompletedDemo: boolean;
    ImagePath: string;
}

export class GroupedStudent {
  StudentID: number;
  Classes: StudentClassMappingModel[];
}
////
export class CurriculumDiagnosticResult {
  AssignmentID: number;
  LessonID: number;
  AttemptID: number;
  CompleteDate: string;
  Name: string;
  Grade: string;
  Standards: CurriculumDiagnosticStandard[];
}

export class CurriculumItemStandardsGrowth {
  StandardID: number;
  LessonID: number;
  StandardName: string;
  StandardDescription: string;
  NeedsAttention: boolean;
  // GrowthItems: CurriculumItemStandardsGrowthItem[]
}

export class CurriculumItemStandardsGrowthItem{
  AssignmentID: number;
  LessonID: number;
  LessonName: string;
  Sequence: number;
  CompletedDate: string;
  IsDiagnostic: boolean;
  IsLesson: boolean;
  IsProficient: boolean;
  LessonGrade: string;
}

export class CurriculumViewAttempt {
  SubmittedAsComplete: boolean;
  SentBack: boolean;
  Graded: boolean;
  Grade: string;
  AttemptID: number;
  Status: string;
  CompleteDate: string;
  CurriculumItemID: number;
  Sequence: number;
  AssignmentID: number;
  LessonName: string;
  LessonID: number;
}

export class CurriculumViewItem {
  Sequence: number;
  CurriculumItemID: number;
  AssignmentID: number;
  LessonID: number;
  LessonName: string;
  LessonGrade: string; // latest attempt grade - whitespace if no attempts
  LessonDescription: string;
  CanContinue: boolean;
  CanRetake: boolean;
  CanStart: boolean;
  CompletedWithProficiency: Boolean; // suggested completed 
  ExternalUrl: string;
  Suggested: boolean; //suggested
  HasCompletedAttempt: boolean;
  CurrentAttemptId: number;
  ImagePath: string;
  Attempts: CurriculumViewAttempt[];
  StandardsGrowth: CurriculumItemStandardsGrowth[];

  IsFormativeAssessment: boolean;
  IsDiagnosticExam: boolean;
  StudentConsumerCurriculumID: number;
  //Static list of standards
  //suggested tag on any standards
  // DiagnosticResults: CurriculumDiagnosticResult[];
}

export class CurriculumViewGroup {
  Sequence: number;
  GroupName: string;
  Hide: boolean;
  Items: CurriculumViewItem[];
}

export class CurriculumViewListing {
  IsTeacher: boolean;
  HBFullName: string;
  HasDemoCompleted: boolean;
  HasLessonMax: boolean;
  HasCompletedPreCourseDiagnostic: boolean;
  HBClassID: number;
  StudentFullName: string;
  StudentID: number;
  Groups: CurriculumViewGroup[];
}

export class CurriculumDiagnosticStandard {
  StandardID: number;
  StandardName: string;
  StandardDescription: string;
  Proficient: boolean; // suggested = false
}

export class CurriculumProductLevelPrice
{
    CurriculumProductLevelID: number;
    ICurriculumProductLevel: CurriculumProductLevel;
    DefaultPrice: number;
    Active: boolean;
}

export class CurriculumProductLevel{
  ID: number;
  Name: string;
  Description: string;
  Config: CurriculumProductLevelConfig;
}

export class CurriculumProductLevelConfig{
  HasLessonMax: boolean;
  LessonMax: number;
}

export class PaymentProviderRequestResult
{
  Success: boolean;
  RequestUrl: string;
  ResultMessage: string;
}

export class PaymentFailureRedirectModel{
  CurriculumID: number;
  StudentID: number;
  CurriculumProductLevelID: number;
}

export class PaymentSuccessRedirectModel{
  ClassID: number;
  Success: boolean;
}

export class SelfServiceGetLessonModel{
  LessonID: number;
  ClassID: number;
}

export class SelfGetLessonReturnModel{
  Success: boolean;
  ErrorMessage: string;
  AssignmentID: number;
}

export class GetDemoRedirectModel{
  CurriculumID: number;
  StudentID: number;
  CurriculumName: string;
}

export class DemoRedirectModel{
  Success: boolean;
  URL: string;
}

export class DemoRedirectModelError extends DemoRedirectModel{}
export class DemoRedirectModelSuccess extends DemoRedirectModel{}

export class ConsumerCurriculumJargon{
  DemoNoCaps: string;
  DemoAllFirstLetterCaps: string;
  DemoJustFirstLetterCaps:string;
}

export class DiagnosticReportRequest{
  StudentConsumerCurriculumID: number;
}

export class DiagnosticReport{
  CourseName: string;
  NonProficientStandardLessons: DiagnosticReportLesson[];
  StandardsNotTestedLessons: DiagnosticReportLesson[];
  ProficientStandards: DiagnosticReportStandard[];
  TotalLessons: number;
  AOILessonCount: number;
  AOELessonCount: number;

}
export class DiagnosticReportLesson{
  LessonName: string;
  Standards: DiagnosticReportStandard[];
}

export class DiagnosticReportStandard{
  StandardCode: string;
  StandardDescription: string;
  Proficient: boolean;
}

export class StudentConsumerCurriculumRequest {
  StudentID: number;
  CurriculumID: number;
}

export class StudentConsumerCurriculum{
  ID: number;
  StudentUserID: number;
  HBClassID: number;
  CurriculumID: number;
  CustID: number;
  ConsumerCurriculumID: number;
  HasDemoCompleted: boolean;
  HasCompletedPreCourseDiagnostic: boolean;
  PurchaseDate: string;
  ReadOnly: boolean;
  Active: boolean;
} 

export class LoginAsStudentModel{
  StudentID: number;
}

export class DemoResultData{
  StudentConsumerCurriculumID: number;
  StudentName: string;
  IsStudent: boolean;
  CurriculumName: string;


  LessonsIdentified: number; 
  StandardsIdentified: number;

  TotalLessons: number;
  TotalStandards: number;

  MissedLessons: number;
  FullPrice: number;
  BasicPrice: number;

  UnitTestsAvailable: boolean;

}

export class EmailConfirmationModel{
  FullName: string;
  Success: boolean;
  GUID: string;
}



/////////////////// Standards Growth Report

export class StandardsGrowthReportModel{
  Standards: StandardGrowthModel[];
}


export class StandardGrowthModel{
  StandardName: string;
  StandardDescription: string;
  Suggested: boolean;
  ProficientLessons: number;
  AchievementComplete: number;
  LessonProgress: StandardGrowthLessonProgressModel[];
}

export class StandardGrowthLessonProgressModel{
  LessonName: string;
  Sequence: number;
  IsDiagnostic: boolean;
  Attempts: StandardGrowthAttempt[];
}

export class StandardGrowthAttempt{
  AttemptID: number;
  AssignmentID: number;
  Grade: string;
  Status: string;
  CompleteDate: string;

}

/////////////////////////////////////////////

/////////////// Router Guard Models \\\\\\\\\\\\\\\

export class NotLoggedInReturnModel{
  LoginURL: string;
  LoggedIn: boolean;
}


///////////////////////////////////////////////////